import {decorate, action, computed, observable} from "mobx";

/**
 * A store for managing and interacting with survey section references inside a survey page.
 */
class SurveySectionStore {
    /**
     * A Map of section refs.
     * @type {Map<string, React.RefObject<HTMLElement>>}
     */
    sectionRefs = new Map();

    /**
     * Whether the sections panel should be shown to the user
     * @type {boolean}
     */
    shouldShowSectionNavPanel = true;
    
    /**
     * Used by the observer to get the ref of the section
     * @param {string} id
     * @returns {React.RefObject<HTMLElement>|undefined}
     */
    getSectionRef(id) {
        return this.sectionRefs.get(id);
    }

    /**
     * Called by each <SurveySection> on mount event
     * @param {string} id
     * @param {React.RefObject<HTMLElement>} ref
     */
    registerSectionRef(id, ref) {
        this.sectionRefs.set(id, ref);
    }
    
    /**
     * Called when a <SurveySection> unmounts
     * @param {string} id
     */
    unregisterSectionRef(id) {
        this.sectionRefs.delete(id);
    }
    
    /**
     * Clear refs on a new page mount
     */
    clearSectionRefs() {
        this.sectionRefs.clear();
    }

    /**
     * Expose the list of all registered section ids
     * @return {string[]}
     */
    get registeredSectionIds()  {
        return Array.from(this.sectionRefs.keys());
    }
}

decorate(SurveySectionStore, {
    sectionRefs: observable,
    shouldShowSectionNavPanel: observable,
    registerSectionRef: action,
    unregisterSectionRef: action,
    clearSectionRefs: action,
    registeredSectionIds: computed
});

export default new SurveySectionStore();